import { AHText, Circle } from "arkh";

export function IssueBadge(props: {
  count: number;
  size?: "small" | "smallMedium";
}) {
  if (props.count === 0) {
    return null;
  }
  return (
    <Circle allowGrow color="negative" size={props.size ?? "small"}>
      <AHText
        type={props.size === "smallMedium" ? "subtitle" : "info-small"}
        color="text-inverted"
        spaceHorizontal="xxsmall"
        textAlign="center"
        numberOfLines={1}
      >
        {props.count}
      </AHText>
    </Circle>
  );
}
